var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path60, _path61, _path62, _ellipse12, _rect, _path63, _ellipse13, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1276,
    height: 858,
    viewBox: "0 0 1276 858",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.806165,
    cx: 742,
    cy: 687.765,
    rx: 174,
    ry: 20.7645,
    fill: "#E2EBFC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.806165,
    cx: 94,
    cy: 694.232,
    rx: 94,
    ry: 18.2323,
    fill: "#E2EBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.999 323.576L540.228 234.511C541.934 233.486 544.147 234.038 545.172 235.744L611.043 345.372C612.068 347.077 611.516 349.291 609.81 350.315L461.581 439.381C459.875 440.405 457.662 439.853 456.637 438.148L390.766 328.52C389.741 326.815 390.293 324.601 391.999 323.576Z",
    fill: "url(#paint0_linear_213_5396)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M432.009 328.957L526.196 272.363C527.049 271.851 528.155 272.127 528.668 272.979L570.417 342.462C570.93 343.315 570.654 344.421 569.801 344.934L475.613 401.527C474.761 402.04 473.654 401.764 473.142 400.911L431.392 331.428C430.88 330.576 431.156 329.469 432.009 328.957Z",
    fill: "url(#paint1_linear_213_5396)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M515.748 361.651C505.942 367.544 493.215 364.37 487.322 354.564C481.43 344.757 484.603 332.03 494.41 326.138C504.216 320.245 516.943 323.418 522.836 333.225C528.728 343.032 525.555 355.759 515.748 361.651Z",
    fill: "url(#paint2_linear_213_5396)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M500.029 339.101L510.904 338.505C511.898 338.45 512.747 339.211 512.802 340.205C512.821 340.566 512.732 340.925 512.545 341.235L506.913 350.557C506.398 351.409 505.291 351.682 504.439 351.167C504.188 351.016 503.978 350.805 503.827 350.553L498.584 341.828C498.071 340.975 498.347 339.868 499.2 339.356C499.452 339.205 499.736 339.117 500.029 339.101Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M432.009 328.957L526.196 272.363C527.049 271.851 528.155 272.127 528.668 272.979L533.771 281.472L436.495 339.921L431.392 331.428C430.88 330.576 431.156 329.469 432.009 328.957Z",
    fill: "url(#paint3_linear_213_5396)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.815 333.122C439.963 333.634 438.856 333.359 438.343 332.506C437.831 331.653 438.107 330.546 438.96 330.034C439.813 329.522 440.919 329.797 441.432 330.65C441.944 331.503 441.668 332.61 440.815 333.122Z",
    fill: "#F2F5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M446.22 329.875C445.367 330.387 444.26 330.111 443.748 329.259C443.235 328.406 443.511 327.299 444.364 326.787C445.217 326.274 446.324 326.55 446.836 327.403C447.348 328.256 447.072 329.363 446.22 329.875Z",
    fill: "#F2F5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.298 221.824L339.953 321.012C341.583 322.153 341.979 324.4 340.838 326.029L267.48 430.795C266.339 432.425 264.092 432.821 262.462 431.68L120.807 332.492C119.177 331.351 118.781 329.104 119.922 327.474L193.28 222.708C194.422 221.079 196.668 220.682 198.298 221.824Z",
    fill: "url(#paint4_linear_213_5396)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.398 279.609L283.799 326.104C284.614 326.674 284.812 327.797 284.242 328.612L251.073 375.983C250.502 376.798 249.379 376.996 248.564 376.425L182.163 329.931C181.348 329.36 181.15 328.237 181.72 327.422L214.889 280.051C215.46 279.237 216.583 279.039 217.398 279.609Z",
    fill: "url(#paint5_linear_213_5396)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.923 278.576L285.275 327.137L231.034 331.066L215.923 278.576Z",
    fill: "url(#paint6_linear_213_5396)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.077 315.887L381.046 410.071C379.378 411.155 377.146 410.68 376.063 409.012L306.406 301.749C305.322 300.081 305.796 297.849 307.465 296.766L452.496 202.582C454.165 201.498 456.396 201.972 457.48 203.641L527.136 310.903C528.22 312.572 527.746 314.803 526.077 315.887Z",
    fill: "url(#paint7_linear_213_5396)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M467.441 309.934L399.458 354.083C398.624 354.625 397.508 354.388 396.966 353.553L365.471 305.054C364.929 304.22 365.166 303.104 366 302.563L433.983 258.414C434.818 257.872 435.933 258.109 436.475 258.944L467.971 307.443C468.513 308.277 468.275 309.393 467.441 309.934Z",
    fill: "url(#paint8_linear_213_5396)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M468.952 308.953L397.947 355.064L414.624 303.302L468.952 308.953Z",
    fill: "url(#paint9_linear_213_5396)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.6 223.06L471.579 293.397C473.397 294.206 474.214 296.336 473.405 298.154L421.385 414.992C420.576 416.81 418.446 417.627 416.629 416.818L258.65 346.481C256.832 345.672 256.015 343.542 256.824 341.725L308.844 224.886C309.653 223.069 311.783 222.251 313.6 223.06Z",
    fill: "url(#paint10_linear_213_5396)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M334.295 272.615C334.608 271.679 335.616 271.17 336.555 271.472L354.381 277.201C355.271 277.486 355.794 278.405 355.586 279.316L354.47 284.209C354.285 285.019 354.678 285.85 355.421 286.222L415.897 316.409C415.908 316.415 415.919 316.421 415.93 316.427C416.811 316.89 417.149 317.979 416.686 318.86L390.253 369.123C389.812 369.962 388.797 370.315 387.931 369.933L314.328 337.433C313.477 337.057 313.052 336.096 313.347 335.213L334.295 272.615Z",
    fill: "url(#paint11_linear_213_5396)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M314.396 334.745L339.493 291.201C339.957 290.395 340.96 290.075 341.805 290.463L425.079 328.709C425.983 329.124 426.38 330.194 425.965 331.098C425.885 331.271 425.779 331.43 425.649 331.57L389.904 370.152C389.375 370.723 388.539 370.89 387.832 370.565L315.207 337.282C314.302 336.867 313.905 335.798 314.319 334.894C314.343 334.843 314.368 334.793 314.396 334.745Z",
    fill: "url(#paint12_linear_213_5396)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306 663L375 685L728 664L655 642.5L306 663Z",
    fill: "#E2EBFC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306 663L273.482 685L107.123 664L141.526 642.5L306 663Z",
    fill: "#E2EBFC"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.027 355.147L290.738 328.127V669.482L143.027 650.568V355.147Z",
    fill: "url(#paint13_linear_213_5396)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.737 328.127L143.026 355.147V488.447H272.723L290.737 328.127Z",
    fill: "#E2EBFC"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.027 355.147L290.737 328.127L254.71 479.44H107L143.027 355.147Z",
    fill: "url(#paint14_linear_213_5396)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M290.737 328.127L605.973 355.147V651.469L290.737 669.482V328.127Z",
    fill: "url(#paint15_linear_213_5396)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M291.161 368.512C291.161 368.512 338.284 404.497 333.889 477.537C329.494 550.578 448.847 479.358 440.397 535.89C431.948 592.422 541.262 562 533.178 596.827C525.095 631.655 604.568 605.274 604.568 651.465L290.541 669.468L291.161 368.512Z",
    fill: "url(#paint16_linear_213_5396)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M314.155 607.59L344.076 608.003V638.28L314.155 639.989V607.59Z",
    fill: "#79A4DD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M357.413 607.59L445.909 608.813V616.4L357.413 616.053V607.59Z",
    fill: "#79A4DD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M357.413 622.367L402.239 622.074V629.661L357.413 630.83V622.367Z",
    fill: "#79A4DD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.973 355.147L290.737 328.127L299.744 489.347H605.973V355.147Z",
    fill: "#E2EBFC"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M290.737 328.127L605.973 355.147L642 471.334H326.764L290.737 328.127Z",
    fill: "url(#paint17_linear_213_5396)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.399 463.012C149.099 460.012 152.1 457.912 156.3 456.712C160.5 455.512 165.999 454.912 172.699 454.912C179.399 454.912 184.9 455.612 189 457.012C193.1 458.412 195.999 460.712 197.699 463.812C199.399 466.912 200.4 469.812 200.8 472.312C201.1 474.912 201.3 478.612 201.3 483.612V662.912C201.3 671.312 200.299 677.512 198.199 681.412C196.199 685.412 193 688.012 188.8 689.312C184.6 690.612 179.399 691.212 173.199 691.212C166.999 691.212 161.999 690.712 158.399 689.612C154.699 688.512 152 687.212 150 685.712C148.1 684.212 146.7 682.012 145.8 679.312C144.5 675.612 143.899 670.112 143.899 662.512V623.212H56.4995C41.3995 623.212 32.4995 619.112 29.6995 610.912C28.5995 607.512 28.0996 602.812 28.0996 597.012C28.0996 591.212 28.3996 586.912 29.0996 584.112L55.8994 476.112C57.1994 471.212 58.2996 467.412 59.2996 464.812C60.2996 462.212 62.1996 459.812 65.0996 457.412C67.9996 455.012 71.6995 453.912 76.1995 453.912C80.6995 453.912 85.6995 454.712 90.9995 456.212C106 460.312 113.6 467.212 113.6 476.812C113.6 480.212 112.8 484.812 111.3 490.312C111.1 490.712 111 491.112 111 491.312L91.2996 570.012H143.899V482.012C143.899 477.112 144.099 473.412 144.399 471.012C144.699 468.712 145.699 466.012 147.399 463.012Z",
    fill: "#22C55E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M173.2 694.312C166.6 694.312 161.5 693.712 157.5 692.612C153.4 691.412 150.4 690.012 148.1 688.212C145.7 686.312 143.9 683.712 142.9 680.312C141.5 676.312 140.8 670.512 140.8 662.612V626.312H56.3999C39.9999 626.312 30 621.512 26.8 612.012C25.6 608.212 25 603.312 25 597.212C25 591.112 25.3 586.712 26 583.612L52.8 475.512C54.1 470.412 55.3 466.612 56.3 463.912C57.4 460.812 59.7 457.912 63 455.212C66.4 452.412 70.8 451.012 76 451.012C80.8 451.012 86.0001 451.812 91.6001 453.412C108 457.912 116.4 465.812 116.4 476.912C116.4 480.612 115.6 485.312 114 491.212L113.9 491.512L113.8 491.812L113.7 492.112L95 567.112H140.7V482.112C140.7 477.012 140.9 473.312 141.2 470.712C141.6 467.912 142.7 464.912 144.6 461.612C146.7 457.912 150.3 455.312 155.3 453.912C159.8 452.612 165.6 452.012 172.6 452.012C179.7 452.012 185.5 452.812 189.9 454.312C194.7 455.912 198.2 458.712 200.3 462.512C202.2 465.912 203.3 469.212 203.7 472.112C204 474.812 204.2 478.612 204.2 483.812V663.112C204.2 672.012 203.1 678.612 200.8 683.012C198.4 687.712 194.6 690.912 189.7 692.412C185.3 693.612 179.7 694.312 173.2 694.312ZM76.1001 456.912C72.3001 456.912 69.1999 457.812 66.8999 459.812C64.3999 461.812 62.8 463.912 62 465.912C61.1 468.412 60 472.112 58.7 476.912L31.8999 584.912C31.2999 587.412 31 591.512 31 597.112C31 602.612 31.5 607.012 32.5 610.112C34.8 616.812 42.7999 620.312 56.3999 620.312H146.8V662.612C146.8 669.812 147.4 675.112 148.6 678.412V678.512C149.3 680.712 150.3 682.312 151.8 683.512C153.4 684.812 155.9 685.912 159.2 686.912C162.6 687.912 167.3 688.412 173.2 688.412C179.1 688.412 184.1 687.812 188 686.612C191.4 685.512 193.9 683.512 195.6 680.212C197.4 676.712 198.3 670.912 198.3 663.012V483.612C198.3 478.812 198.1 475.112 197.8 472.712C197.5 470.512 196.6 468.012 195.1 465.212C193.7 462.712 191.4 461.012 188 459.812C184.2 458.512 179.1 457.912 172.7 457.912C166.2 457.912 161 458.512 157.1 459.612C153.7 460.612 151.3 462.212 150 464.512C148.5 467.212 147.6 469.512 147.3 471.512C147 473.712 146.8 477.312 146.8 482.112V573.112H87.3999L107.9 490.912C108 490.412 108.1 489.912 108.4 489.412C109.8 484.212 110.5 480.012 110.5 476.912C110.5 468.712 103.8 462.912 90.1001 459.212C85.1001 457.712 80.3001 456.912 76.1001 456.912Z",
    fill: "#B7FFD1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M626.399 463.012C628.099 460.012 631.1 457.912 635.3 456.712C639.5 455.512 644.999 454.912 651.699 454.912C658.399 454.912 663.9 455.612 668 457.012C672.1 458.412 674.999 460.712 676.699 463.812C678.399 466.912 679.4 469.812 679.8 472.312C680.1 474.912 680.3 478.612 680.3 483.612V662.912C680.3 671.312 679.299 677.512 677.199 681.412C675.199 685.412 672 688.012 667.8 689.312C663.6 690.612 658.399 691.212 652.199 691.212C645.999 691.212 640.999 690.712 637.399 689.612C633.699 688.512 631 687.212 629 685.712C627.1 684.212 625.7 682.012 624.8 679.312C623.5 675.612 622.899 670.112 622.899 662.512V623.212H535.5C520.4 623.212 511.499 619.112 508.699 610.912C507.599 607.512 507.1 602.812 507.1 597.012C507.1 591.212 507.4 586.912 508.1 584.112L534.899 476.112C536.199 471.212 537.3 467.412 538.3 464.812C539.3 462.212 541.2 459.812 544.1 457.412C547 455.012 550.699 453.912 555.199 453.912C559.699 453.912 564.7 454.712 570 456.212C585 460.312 592.6 467.212 592.6 476.812C592.6 480.212 591.8 484.812 590.3 490.312C590.1 490.712 590 491.112 590 491.312L570.3 570.012H622.899V482.012C622.899 477.112 623.099 473.412 623.399 471.012C623.699 468.712 624.699 466.012 626.399 463.012Z",
    fill: "#22C55E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M652.2 694.312C645.6 694.312 640.5 693.712 636.5 692.612C632.5 691.412 629.4 690.012 627.1 688.212C624.7 686.312 622.9 683.712 621.9 680.312C620.5 676.312 619.8 670.512 619.8 662.612V626.312H535.4C519 626.312 509 621.512 505.8 612.012C504.6 608.212 504 603.312 504 597.212C504 591.112 504.3 586.712 505 583.612L531.8 475.512C533.1 470.412 534.3 466.612 535.3 463.912C536.5 460.812 538.7 457.912 542 455.212C545.4 452.412 549.8 451.012 555 451.012C559.8 451.012 565 451.812 570.6 453.412C587 457.912 595.4 465.812 595.4 476.912C595.4 480.612 594.6 485.312 593 491.212L592.9 491.512L592.8 491.812L592.7 492.112L574 567.112H619.7V482.112C619.7 477.012 619.9 473.312 620.2 470.712C620.6 467.912 621.7 464.912 623.6 461.612C625.7 457.912 629.3 455.312 634.3 453.912C638.8 452.612 644.6 452.012 651.6 452.012C658.7 452.012 664.5 452.812 668.9 454.312C673.7 455.912 677.2 458.712 679.3 462.512C681.2 465.912 682.3 469.212 682.7 472.112C683 474.812 683.2 478.612 683.2 483.812V663.112C683.2 672.012 682.1 678.612 679.8 683.012C677.4 687.712 673.6 690.912 668.7 692.412C664.3 693.612 658.7 694.312 652.2 694.312ZM555.1 456.912C551.3 456.912 548.2 457.812 545.9 459.812C543.4 461.812 541.8 463.912 541 465.912C540.1 468.412 539 472.112 537.7 476.912L510.9 584.912C510.3 587.412 510 591.512 510 597.112C510 602.612 510.5 607.012 511.5 610.112C513.8 616.812 521.8 620.312 535.4 620.312H625.8V662.612C625.8 669.812 626.4 675.112 627.6 678.412V678.512C628.3 680.712 629.3 682.312 630.8 683.512C632.4 684.812 634.9 685.912 638.2 686.912C641.6 687.912 646.3 688.412 652.2 688.412C658.1 688.412 663.1 687.812 667 686.612C670.4 685.512 672.9 683.512 674.6 680.212C676.4 676.712 677.3 670.912 677.3 663.012V483.612C677.3 478.812 677.1 475.112 676.8 472.712C676.5 470.512 675.6 468.012 674.1 465.212C672.7 462.712 670.4 461.012 667 459.812C663.2 458.512 658.1 457.912 651.7 457.912C645.2 457.912 640 458.512 636.1 459.612C632.7 460.612 630.3 462.212 629 464.512C627.5 467.212 626.6 469.512 626.3 471.512C626 473.712 625.8 477.312 625.8 482.112V573.112H566.4L586.9 490.912C587 490.412 587.1 489.912 587.4 489.412C588.8 484.212 589.5 480.012 589.5 476.912C589.5 468.712 582.8 462.912 569.1 459.212C564.1 457.712 559.3 456.912 555.1 456.912Z",
    fill: "#B7FFD1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M200.4 781.712L190.9 779.612L188.7 770.112C188.6 769.812 188.3 769.512 188 769.512C187.7 769.512 187.4 769.712 187.3 770.112L185.1 779.712L175.6 782.012C175.3 782.112 175 782.412 175 782.712C175 783.012 175.2 783.312 175.6 783.412L185.1 785.512L187.3 795.012C187.4 795.312 187.7 795.612 188 795.612C188.3 795.612 188.6 795.412 188.7 795.012L190.9 785.412L200.4 783.112C200.7 783.012 201 782.712 201 782.412C201 782.012 200.8 781.712 200.4 781.712Z",
    fill: "#B7FFD1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M276.6 375.412L269.6 373.912L268 366.912C267.9 366.712 267.7 366.512 267.5 366.512C267.2 366.512 267 366.712 267 366.912L265.4 373.912L258.4 375.612C258.2 375.712 258 375.912 258 376.112C258 376.412 258.2 376.612 258.4 376.612L265.4 378.112L267 385.112C267.1 385.312 267.3 385.512 267.5 385.512C267.8 385.512 268 385.312 268 385.112L269.6 378.112L276.6 376.412C276.8 376.312 277 376.112 277 375.912C277 375.712 276.8 375.412 276.6 375.412Z",
    fill: "#B7FFD1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M542.7 804.111L553.3 801.811L555.7 791.211C555.8 790.811 556.1 790.611 556.5 790.611C556.9 790.611 557.2 790.911 557.3 791.211L559.7 801.911L570.3 804.411C570.7 804.511 570.9 804.811 570.9 805.211C570.9 805.611 570.6 805.911 570.2 806.011L559.6 808.311L557.2 818.911C557.1 819.311 556.8 819.511 556.4 819.511C556 819.511 555.7 819.211 555.6 818.911L553.2 808.211L542.6 805.711C542.2 805.611 542 805.311 542 804.911C542 804.511 542.3 804.111 542.7 804.111Z",
    fill: "#B7FFD1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M523.3 758.512L528.8 757.312L530 751.812C530 751.612 530.2 751.512 530.4 751.512C530.6 751.512 530.8 751.612 530.8 751.812L532.1 757.312L537.6 758.612C537.8 758.612 537.9 758.812 537.9 759.012C537.9 759.212 537.8 759.412 537.6 759.412L532.1 760.612L530.9 766.112C530.9 766.312 530.7 766.412 530.5 766.412C530.3 766.412 530.1 766.312 530.1 766.112L528.8 760.612L523.3 759.312C523.1 759.312 523 759.112 523 758.912C523 758.712 523.1 758.612 523.3 758.512Z",
    fill: "#B7FFD1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M485.8 347.512C485.8 347.512 459.5 338.112 419.9 357.512C417.4 358.712 417.7 362.412 420.4 363.212C429.7 365.812 444.9 370.512 451.1 374.312L485.8 347.512Z",
    fill: "#B7FFD1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M505.5 386.312C505.5 386.312 497.6 413.113 458.6 433.713C456.1 435.013 453.4 432.613 454.3 429.913C457.6 420.913 462.9 405.813 463.4 398.513L505.5 386.312Z",
    fill: "#B7FFD1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M456.601 364.212C453.601 366.712 450.5 369.312 447.4 372.112L463.101 402.912C467.201 402.012 471.1 401.112 474.9 400.112C532.5 385.412 559.5 363.312 572.2 346.512L557.2 317.112C536.1 317.412 502.401 326.312 456.601 364.212Z",
    fill: "#22C55E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M539.166 360.285C545.96 356.831 548.667 348.523 545.213 341.73C541.759 334.936 533.451 332.228 526.658 335.682C519.864 339.137 517.157 347.444 520.611 354.238C524.065 361.032 532.372 363.739 539.166 360.285Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M572.2 346.412L557.2 317.012C574.4 316.712 583.2 322.112 583.2 322.112L583.3 322.312C583.3 322.312 582.5 332.612 572.2 346.412Z",
    fill: "#B7FFD1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M494.5 366.612C495.4 368.312 494.8 370.412 493.2 371.412L474.2 383.412C470.3 385.912 466.1 388.012 461.8 389.712L440.9 398.012C439.1 398.712 437.1 397.912 436.2 396.212C435.3 394.512 435.9 392.412 437.5 391.412L456.5 379.412C460.4 376.912 464.6 374.812 468.9 373.112L489.8 364.812C491.6 364.212 493.6 364.912 494.5 366.612Z",
    fill: "#B7FFD1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M214 363.512C214 363.512 207.9 346.812 191.8 351.412C191.8 351.412 189.8 327.112 163.5 325.612C137.2 324.112 129.1 344.812 129.1 344.812C129.1 344.812 106.9 332.712 91.7 351.412C91.7 351.412 74.5 351.412 71 363.512H214Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M216.9 365.512H68.2998L68.9998 362.912C72.3998 351.112 86.7997 349.612 90.6997 349.412C104 333.812 122.3 339.712 128.1 342.212C131 336.912 141 322.312 163.5 323.612C186.3 324.912 192 342.612 193.3 349.012C206.2 346.612 213.6 356.812 215.8 362.912L216.9 365.512ZM73.8997 361.512H210.8C208.5 357.412 202.7 350.312 192.3 353.312L190 354.012L189.8 351.612C189.7 350.712 187.6 329.012 163.4 327.612C139 326.212 131.3 344.812 131 345.512L130.2 347.612L128.2 346.512C127.4 346.012 107.2 335.412 93.2998 352.612L92.6997 353.312H91.6997C91.4997 353.412 78.4997 353.512 73.8997 361.512Z",
    fill: "#F7FAFC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M731.9 404.012C731.9 404.012 727.5 392.012 715.9 395.312C715.9 395.312 714.4 377.912 695.5 376.812C676.6 375.712 670.8 390.612 670.8 390.612C670.8 390.612 654.8 381.912 643.9 395.312C643.9 395.312 631.5 395.312 629 404.012H731.9Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M734.7 406.012H626.3L627 403.412C629.5 394.812 639.7 393.512 642.9 393.312C652.4 382.412 665.1 386.012 669.8 387.912C672.2 383.712 679.6 373.812 695.6 374.712C711.8 375.612 716.3 387.812 717.4 392.812C726.7 391.412 732.1 398.812 733.7 403.212L734.7 406.012ZM632.2 402.012H728.6C726.7 399.212 722.9 395.412 716.4 397.212L714.1 397.912L713.9 395.512C713.8 394.912 712.3 379.812 695.4 378.812C678.1 377.812 672.7 391.212 672.7 391.312L671.9 393.412L669.9 392.312C669.3 392.012 655.2 384.612 645.5 396.512L644.9 397.212H643.9C643.8 397.312 635.8 397.412 632.2 402.012Z",
    fill: "#F7FAFC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M427.2 407.513C427.6 410.413 427.7 415.213 418.3 416.713C418.3 416.713 413.8 427.113 402.3 422.513C402.3 422.513 402.3 436.413 386.1 431.713C386.1 431.713 383.8 461.713 356.1 452.513C356.1 452.513 344.6 464.013 333 459.413C333 459.413 335.3 477.913 316.8 477.913C316.8 477.913 312.2 489.413 300.6 484.813C300.6 484.813 302.9 498.713 289.1 501.013C289.1 501.013 291.4 517.213 277.6 519.513C277.6 519.513 277.6 538.013 266.1 544.913C266.1 544.913 298.4 563.413 280 593.413C280 593.413 300.8 600.313 284.6 623.413C284.6 623.413 305.4 628.013 293.8 648.813C293.8 648.813 319.2 653.413 305.3 678.813C305.3 678.813 335.3 671.913 342.2 701.913C342.2 701.913 353.7 699.613 360.7 706.513C360.7 706.513 365.3 695.013 376.9 697.313C376.9 697.313 376.9 671.913 400 671.913C400 671.913 400 653.413 418.5 646.513C418.5 646.513 413.9 628.013 423.1 623.413C423.1 623.413 404.6 591.113 437 581.813C437 581.813 427.8 570.313 437 556.413C437 556.413 425.5 549.513 427.8 537.913C427.8 537.913 407 531.013 413.9 510.213C413.9 510.213 404.7 505.613 407 491.713C407 491.713 395.5 475.513 411.6 468.613C411.6 468.613 423.1 466.313 425.5 480.113C425.5 480.113 455.5 470.913 455.5 503.213C455.5 503.213 476.3 505.513 469.4 528.613C469.4 528.613 499.4 544.813 467.1 577.113C467.1 577.113 474 586.313 467.1 597.913C467.1 597.913 481 609.413 464.8 625.613C464.8 625.613 474 648.713 448.6 667.213C448.6 667.213 462.5 701.813 423.2 706.513C423.2 706.513 420.9 722.713 404.7 722.713C404.7 722.713 400.1 734.213 390.8 731.913C390.8 731.913 381.6 748.113 365.4 736.513C365.4 736.513 349.2 750.413 333.1 731.913C333.1 731.913 314.6 759.613 286.9 738.813C286.9 738.813 277.7 731.913 277.7 713.413C277.7 713.413 263.8 701.913 268.5 688.013C268.5 688.013 238.5 681.113 243.1 646.413C243.1 646.413 213.1 625.613 238.5 593.313C238.5 593.313 224.6 579.413 243.1 554.013C243.1 554.013 215.4 526.313 250 503.213C250 503.213 250 482.413 270.8 477.813C270.8 477.813 273.1 463.913 287 468.613C287 468.613 287 457.113 298.5 459.413C298.5 459.413 300.8 447.913 317 450.213C317 450.213 317 410.913 356.3 424.813C356.3 424.813 359.2 410.513 377.1 417.913C377.1 417.913 381.7 401.713 397.9 411.013C397.9 411.013 406.2 402.613 414.1 407.713C414.1 407.713 416.3 400.613 425.1 403.413C426.4 403.813 427 405.813 427.2 407.513Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M307.2 749.512C299.8 749.512 292.4 746.712 285 741.212C284.6 740.912 275.001 733.512 274.601 714.712C271.401 711.712 262.5 702.012 264.7 689.912C256.9 687.012 236.7 676.612 239.7 647.712C236.1 644.812 227.3 636.412 225.4 623.712C223.9 613.712 226.9 603.512 234.4 593.312C231 588.412 224.9 574.912 239 554.212C235.6 550.112 228.2 539.712 229.5 527.212C230.5 517.512 236.3 508.912 246.9 501.512C247.4 496.312 250.501 480.212 268.101 475.312C268.901 472.912 270.701 468.812 274.601 466.412C277.401 464.712 280.6 464.212 284.2 464.812C284.7 462.712 285.901 460.212 288.101 458.412C290.301 456.612 293 455.812 296.2 456.012C298 452.312 302.601 446.312 313.801 446.812C314.401 441.112 316.701 429.512 325.801 423.112C332.901 418.112 342.4 417.412 354 420.912C355 418.812 356.9 416.112 360.2 414.312C364.2 412.212 369.2 412.012 375 413.912C376.3 411.312 378.801 407.712 383.101 405.912C387.201 404.212 391.9 404.612 397 407.112C400.5 404.312 406.5 401.412 412.4 403.512C413.2 402.512 414.301 401.412 415.801 400.712C418.501 399.312 421.8 399.112 425.5 400.312C427.2 400.812 429.3 402.412 430 406.912C430.9 413.412 427.601 417.512 420.101 419.212C417.801 423.112 412.6 427.812 404.5 426.212C403.9 428.412 402.6 431.112 400 433.012C397 435.212 393.2 436.012 388.4 435.212C387.4 440.112 384.7 448.912 377.4 453.712C371.8 457.412 364.9 458.112 356.7 455.712C353.5 458.412 345.2 464.512 335.9 463.212C335.6 466.612 334.601 471.312 331.301 475.012C328.301 478.412 324.001 480.312 318.601 480.712C316.301 484.812 311.201 489.812 303.601 488.612C303.501 489.912 303.301 491.312 302.801 492.812C301.601 496.612 298.801 501.212 292.101 503.212C292.201 509.612 289.801 518.912 280.301 521.712C279.901 526.612 278.3 537.712 271 544.512C276 548.212 284.6 556.012 287.5 567.312C289.5 575.312 288.4 583.512 284 591.812C286.9 593.512 291 596.612 292.7 602.012C294.6 607.712 293.3 614.312 289 621.612C292.2 623.012 296.601 625.812 298.801 630.712C300.901 635.312 300.6 640.712 297.9 646.712C301.8 648.112 307.701 651.212 310.601 657.212C313.001 662.212 312.9 668.212 310.2 674.912C313.3 674.712 317.4 674.912 321.7 675.912C329.7 677.812 339.901 683.312 344.301 698.312C347.901 698.012 354.201 698.212 359.601 701.612C362.201 697.712 367 693.512 373.9 693.612C374.9 684.012 380.701 670.012 397.101 668.612C397.901 663.012 401.3 650.512 414.9 644.312C414 639.112 412.801 627.612 419.101 622.012C416.701 616.912 412.2 604.712 416.5 593.912C419.1 587.512 424.4 582.712 432.2 579.712C429.6 574.412 427.901 565.812 432.801 556.812C429.401 554.012 423.701 548.012 424.301 539.412C416.501 535.912 406.2 526.712 410.2 511.012C407.2 508.612 402.201 502.812 403.601 492.012C402.001 489.412 398.401 482.412 400.301 475.712C401.601 471.212 404.9 467.812 410.2 465.512L410.5 465.412L410.801 465.312C411.001 465.312 416.601 464.212 421.601 467.612C424.401 469.512 426.4 472.412 427.5 476.212C432.3 475.312 441.7 474.612 449 479.912C454.7 484.112 457.8 491.012 458.2 500.412C461.5 501.312 467 503.412 470.5 508.712C473.7 513.512 474.401 519.612 472.601 526.912C476.101 529.412 483.101 535.412 484.601 545.212C486.101 555.212 481.401 565.912 470.601 577.212C472.401 580.812 474.9 588.212 470.5 597.012C472.4 599.212 475.101 603.312 475.301 608.812C475.601 614.612 473.1 620.412 467.9 626.112C469.5 632.212 472.6 651.712 451.9 667.912C453.4 672.812 456 684.712 450 694.712C445.5 702.312 437.3 707.012 425.5 708.812C423.8 715.212 418.4 724.312 406.5 725.212C404.2 729.612 399.201 735.312 392.101 734.812C390.201 737.312 386.2 741.612 380.2 742.912C375.4 744.012 370.401 742.912 365.301 739.812C360.401 742.912 346.901 749.412 333.101 736.112C329.601 740.112 322.3 747.012 312 748.812C310.5 749.412 308.9 749.512 307.2 749.512ZM281.601 470.712C280.201 470.712 278.9 471.012 277.9 471.712C274.5 473.712 273.7 478.412 273.7 478.412L273.4 480.412L271.4 480.812C253.2 484.812 253 502.512 253 503.312V504.912L251.7 505.812C241.9 512.312 236.6 519.812 235.7 527.912C234.4 540.912 245.1 551.912 245.2 552.012L247 553.812L245.5 555.912C228.9 578.712 240.101 590.812 240.601 591.312L242.4 593.212L240.801 595.312C233.301 604.812 230.2 614.112 231.5 623.012C233.5 636.212 244.6 644.012 244.7 644.112L246.2 645.112L246 646.912C241.8 678.512 268.001 684.912 269.101 685.112L272.301 685.812L271.301 688.912C267.401 700.612 279.501 710.912 279.601 711.012L280.7 711.912V713.312C280.7 729.812 288.401 736.112 288.801 736.312C296.501 742.012 304.001 744.312 311.301 743.112C323.201 741.112 330.6 730.212 330.7 730.112L332.9 726.812L335.5 729.712C349.4 745.612 363.101 734.512 363.601 734.012L365.4 732.512L367.301 733.812C371.501 736.812 375.501 737.912 379.101 737.212C384.901 736.012 388.301 730.212 388.301 730.212L389.4 728.312L391.601 728.812C398.201 730.512 401.9 721.512 401.9 721.412L402.7 719.512H404.7C418 719.512 420.1 706.512 420.2 705.912L420.5 703.612L422.801 703.312C433.801 702.012 441.3 698.112 445 691.812C451 681.612 445.8 668.212 445.7 668.112L444.801 665.912L446.7 664.512C469.8 647.712 462.201 627.312 461.801 626.512L461.101 624.712L462.5 623.312C467.3 618.512 469.6 613.812 469.4 609.212C469.1 603.612 465 600.012 465 600.012L463 598.412L464.301 596.212C470.101 586.612 464.7 579.112 464.5 578.712L463 576.612L464.801 574.812C475.301 564.312 479.9 554.812 478.7 546.312C477.3 536.412 467.901 531.112 467.801 531.112L465.7 529.912L466.4 527.612C468.3 521.112 468.101 515.912 465.601 512.212C462.101 506.912 455.101 506.012 455.101 506.012L452.4 505.712V503.012C452.4 494.312 450.101 488.212 445.601 484.912C438.001 479.312 426.401 482.812 426.301 482.812L423 483.812L422.4 480.412C421.8 476.812 420.401 474.212 418.301 472.712C415.901 471.012 413.201 471.212 412.301 471.312C408.901 472.812 406.9 474.812 406.2 477.412C404.6 483.012 409.301 489.612 409.301 489.712L410 490.712L409.801 491.912C407.901 503.212 414.801 507.112 415.101 507.212L417.301 508.412L416.5 510.812C410.6 528.412 427.7 534.512 428.5 534.712L431 535.512L430.5 538.112C428.6 547.512 438.201 553.412 438.301 553.412L441 555.012L439.301 557.612C431.401 569.512 439.101 579.412 439.101 579.512L441.9 583.012L437.601 584.212C429.601 586.512 424.3 590.512 422 596.112C417.5 607.212 425.4 621.212 425.5 621.412L427.101 624.212L424.301 625.612C418.501 628.512 420.201 641.112 421.301 645.312L421.9 647.912L419.4 648.812C403.2 654.912 402.9 670.712 402.9 671.412V674.412H399.9C380 674.412 379.801 695.912 379.801 696.812V700.512L376.2 699.812C367.2 698.012 363.6 706.812 363.4 707.212L361.7 711.412L358.5 708.212C352.8 702.512 342.8 704.412 342.7 704.412L339.801 705.012L339.101 702.212C336.501 691.012 330.201 684.012 320.301 681.612C312.701 679.812 305.901 681.312 305.801 681.312L299.301 682.812L302.5 676.912C306.4 669.812 307.3 664.012 305.2 659.612C302.1 653.112 293.201 651.312 293.101 651.312L289 650.612L291 646.912C294.1 641.212 294.901 636.612 293.301 632.912C290.901 627.612 283.8 625.912 283.7 625.812L279.301 624.812L281.9 621.112C286.8 614.112 288.5 608.212 287 603.612C285.2 597.912 278.901 595.712 278.801 595.712L275.301 594.512L277.301 591.312C282.101 583.412 283.601 575.812 281.801 568.512C278.401 555.012 264.7 547.112 264.5 547.012L260.101 544.512L264.5 541.912C274.5 535.912 274.601 519.212 274.601 519.112V516.612L277.101 516.212C287.901 514.412 286.2 501.712 286.2 501.112L285.801 498.212L288.7 497.712C293.3 496.912 296.101 494.712 297.301 490.812C298.201 487.812 297.801 485.012 297.801 485.012L296.9 479.712L301.801 481.712C310.001 485.012 313.501 477.912 314.101 476.412L314.9 474.512H316.9C321.4 474.512 324.8 473.312 327 470.812C330.9 466.412 330.101 459.512 330.101 459.412L329.5 454.412L334.2 456.312C343.8 460.112 354.001 450.112 354.101 450.012L355.4 448.712L357.2 449.312C364.3 451.712 370.1 451.412 374.4 448.512C382.2 443.312 383.201 431.212 383.301 431.112L383.601 427.412L387.101 428.412C390.101 429.312 394.2 429.912 396.7 428.012C399.3 426.012 399.4 422.112 399.4 422.012L399.5 417.612L403.601 419.212C411.901 422.512 415.2 416.312 415.7 415.012L416.4 413.512L418 413.212C425.1 412.012 424.7 409.412 424.4 407.312C424.3 406.312 424 405.712 423.9 405.512C421.8 404.912 420.2 404.912 418.9 405.512C417.4 406.312 416.9 407.812 416.9 407.812L415.7 411.612L412.4 409.412C406.7 405.712 400.3 412.012 400 412.312L398.4 413.912L396.4 412.812C392.2 410.412 388.601 409.812 385.801 410.912C381.601 412.612 380 417.912 380 418.012L379.101 421.212L376 419.912C370.7 417.712 366.5 417.412 363.5 419.012C360.1 420.812 359.301 424.612 359.301 424.612L358.601 428.012L355.301 426.912C344.301 423.012 335.7 423.212 329.7 427.412C320.1 434.212 320 449.312 320 449.512V453.012L316.601 452.512C303.801 450.712 301.7 458.512 301.5 459.412L300.9 462.312L298 461.812C295.5 461.312 293.601 461.612 292.301 462.612C290.501 464.112 290 467.112 290 468.112V472.212L286.101 470.912C284.301 470.912 282.901 470.712 281.601 470.712Z",
    fill: "#EDF2F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_213_5396)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M845.679 829.384L1262.93 844.137L1227.3 802.38L863.221 813.707L845.679 829.384Z",
    fill: "url(#paint18_linear_213_5396)",
    fillOpacity: 0.21,
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.0078,
    cy: 5.4,
    rx: 45.0078,
    ry: 5.4,
    transform: "matrix(-1 0 0 1 775.002 810)",
    fill: "url(#paint19_linear_213_5396)",
    fillOpacity: 0.21,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M970.492 722.165C970.492 722.165 981.162 738.744 977.605 760.417C974.048 782.089 974.493 814 974.493 814H962.704L947.989 717.39C947.989 717.39 964.701 711.073 970.492 712.302C976.283 713.531 970.492 722.165 970.492 722.165Z",
    fill: "#9EA4B8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.083 724.912C908.083 724.912 914.749 743.466 906.409 763.783C898.068 784.1 891.323 815.294 891.323 815.294L879.836 812.642L887.23 715.197L916.74 708.736L908.083 724.912Z",
    fill: "#9EA4B8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M974.836 813.6L960.412 809.247L950.713 813.6L937.034 815.024C934.856 815.251 933.035 816.779 932.433 818.885C931.128 823.452 934.557 828 939.308 828H967.636C971.612 828 974.836 824.776 974.836 820.8V813.6Z",
    fill: "#718096"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.021 813.6L877.597 809.247L867.899 813.6L854.219 815.024C852.041 815.251 850.22 816.779 849.618 818.885C848.313 823.452 851.743 828 856.494 828H884.821C888.798 828 892.021 824.776 892.021 820.8V813.6Z",
    fill: "#718096"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.437 721.291V624.6H892.11L881.028 721.291H920.432L932.566 671.507L941.115 721.291H978.437Z",
    fill: "#1A202C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M976.182 597.277C993.691 576.86 994.215 577.337 1001.54 564.911C1005.03 558.979 1009.26 554.18 1008.94 553.559C1004.14 544.358 989.942 535.013 967.135 511.2L976.855 487.512C1009.12 512.53 1020.19 532.575 1025.84 543.387C1027.2 546.008 1029.63 550.771 1029.48 554.033C1028.83 568.397 1011.44 586.741 978.725 608.772L976.182 597.277Z",
    fill: "#9EA4B8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.076 499.698C795.076 499.698 783.323 485.545 782.248 480.89C779.679 477.87 777.729 484.086 777.729 484.086C777.729 484.086 784.854 514.217 791.955 519.018C799.056 523.819 799.056 519.018 799.056 519.018L795.076 499.698Z",
    fill: "#9EA4B8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M717.745 804.805C697.303 776.137 706.585 717.971 754.298 659.191C802.011 600.411 852.162 537.337 791.894 497.737C772.884 485.246 739.08 478.31 712.344 492.657",
    stroke: "#E2E8F0",
    strokeWidth: 1.8
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M798.718 522.397C802.95 523.41 805.271 507.44 801.039 504.516C796.807 501.593 798.813 489.242 795.235 489.793C791.657 490.345 793.403 495.081 793.229 498.46C793.054 501.839 794.486 521.384 798.718 522.397Z",
    fill: "#9EA4B8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M802.852 515.887C823.868 532.672 823.41 533.213 836.084 540.096C842.134 543.381 847.078 547.442 847.687 547.097C856.715 541.977 865.558 527.465 888.56 503.841L912.574 512.728C888.698 545.85 869.051 557.613 858.442 563.629C844.549 571.507 819.871 558 791.453 518.83L802.852 515.887Z",
    fill: "#9EA4B8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.614 404.648C931.614 404.648 931.999 411.601 927.122 415.472C921.677 419.793 915.582 424.788 914.176 426.572C911.509 429.954 916.842 429.954 916.842 429.954L914.176 451.792L936.355 461.717L931.614 480.204H958.186L961.531 461.717C961.531 461.717 953.797 426.999 948.924 417.704C942.321 405.109 931.614 404.648 931.614 404.648Z",
    fill: "#9EA4B8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.2564,
    cy: 38.25,
    rx: 30.2564,
    ry: 38.25,
    transform: "matrix(-1 0 0 1 994.64 386.1)",
    fill: "#1A202C"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6022,
    cy: 11.7,
    rx: 12.6022,
    ry: 11.7,
    transform: "matrix(-1 0 0 1 962.234 381.6)",
    fill: "#1A202C"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.1014,
    cy: 7.52143,
    rx: 8.1014,
    ry: 7.52143,
    transform: "matrix(-1 0 0 1 971.235 381.6)",
    fill: "#1A202C"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6022,
    cy: 11.7,
    rx: 12.6022,
    ry: 11.7,
    transform: "matrix(-1 0 0 1 989.238 388.8)",
    fill: "#1A202C"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6022,
    cy: 11.7,
    rx: 12.6022,
    ry: 11.7,
    transform: "matrix(-1 0 0 1 996.439 401.399)",
    fill: "#1A202C"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.30109,
    cy: 5.85,
    rx: 6.30109,
    ry: 5.85,
    transform: "matrix(-1 0 0 1 980.237 385.199)",
    fill: "#1A202C"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.30109,
    cy: 5.85,
    rx: 6.30109,
    ry: 5.85,
    transform: "matrix(-1 0 0 1 944.23 388.8)",
    fill: "#1A202C"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.30109,
    cy: 5.85,
    rx: 6.30109,
    ry: 5.85,
    transform: "matrix(-1 0 0 1 940.63 397.8)",
    fill: "#1A202C"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.20125,
    cy: 8.1,
    rx: 7.20125,
    ry: 8.1,
    transform: "matrix(-1 0 0 1 942.431 424.8)",
    fill: "#9EA4B8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1017.38 517.321L979.078 481.806C979.078 481.806 960.645 475.199 948.652 475.199C942.814 475.199 951.26 475.199 930.928 475.199C923.413 475.199 901.946 481.806 901.946 481.806L873.647 517.321L891.61 542.821L911.258 517.321L889.344 639.045C889.344 639.045 911.593 646.458 930.928 646.458C950.263 646.458 979.078 639.258 979.078 639.258V525.993L993.228 542.821L1017.38 517.321Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.195312
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941.167 721.427L939.037 652.481L932.72 671.629L941.167 721.427Z",
    fill: "#3B3C45"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.549819
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M898.068 589.914L921.186 511.103C921.186 511.103 911.691 514.07 911.167 517.876C910.642 521.682 898.068 589.914 898.068 589.914Z",
    fill: "#DEEAF4"
  }))), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.30109,
    cy: 16.2,
    rx: 6.30109,
    ry: 16.2,
    transform: "matrix(-1 0 0 1 701.189 782.999)",
    fill: "#302C48"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.6069,
    height: 23.4,
    transform: "matrix(-1 0 0 1 735.395 788.399)",
    fill: "#302C48"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M722.793 788.399H706.59C706.59 788.399 702.99 792.268 702.99 799.934C702.99 807.6 706.59 811.799 706.59 811.799H722.793C722.793 811.799 719.192 806.696 719.192 800.597C719.192 794.498 722.793 788.399 722.793 788.399Z",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.30109,
    cy: 18,
    rx: 6.30109,
    ry: 18,
    transform: "matrix(-1 0 0 1 740.796 781.199)",
    fill: "#686B89"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M633.753 12.0691L651.576 45.5908L674.275 33.5217L633.753 12.0691Z",
    fill: "#4ADE80"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.699 13.6926L648.522 47.2143L625.824 59.2834L630.699 13.6926Z",
    fill: "#22C55E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M671.312 82.7087L653.488 49.187L676.187 37.118L671.312 82.7087Z",
    fill: "#22C55E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.258 84.3333L650.434 50.8116L627.736 62.8807L668.258 84.3333Z",
    fill: "#4ADE80"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M678.001 35.0062L689.291 24.2144L679.011 19.4208L678.001 35.0062Z",
    fill: "#4ADE80"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M678.855 36.477L694.31 34.2245L691.758 45.2764L678.855 36.477Z",
    fill: "#22C55E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.772 62.1444L614.672 73.1316L625.034 77.745L625.772 62.1444Z",
    fill: "#4ADE80"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.893 60.689L609.48 63.2108L611.838 52.1161L624.893 60.689Z",
    fill: "#22C55E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M669.957 85.4375C669.957 91.6336 685.041 118.684 645.764 153.014C606.488 187.343 626.525 232.208 645.764 247.22",
    stroke: "white",
    strokeWidth: 3.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M671.707 112.967L679.916 126.254L686.742 117.195L671.707 112.967Z",
    fill: "#4ADE80"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.062 115.155L656.956 111.189L663.623 102.013L672.062 115.155Z",
    fill: "#22C55E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M653.379 146.323L654.389 161.908L664.668 157.114L653.379 146.323Z",
    fill: "#22C55E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.925 146.629L641.826 135.642L652.188 131.028L652.925 146.629Z",
    fill: "#4ADE80"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.262 182.893L637.175 192.993L640.868 182.268L625.262 182.893Z",
    fill: "#4ADE80"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.825 183.37L610.225 182.633L614.838 172.271L625.825 183.37Z",
    fill: "#22C55E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.944 225.822L645.436 227.805L642.692 216.799L629.944 225.822Z",
    fill: "#22C55E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.643 226.409L615.891 233.812L614.509 222.554L629.643 226.409Z",
    fill: "#4ADE80"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M781.968 181.419C758.32 180.037 722.07 166.212 713.426 121.296C704.782 76.3799 681.643 54.5175 653.899 48.6543",
    stroke: "#B7FFD1",
    strokeWidth: 1.62
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_213_5396",
    x: 832.679,
    y: 789.38,
    width: 443.256,
    height: 67.7568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_213_5396"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_5396",
    x1: 196.839,
    y1: 188.245,
    x2: 34.4262,
    y2: 760.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_213_5396",
    x1: 358.372,
    y1: 136.864,
    x2: 358.372,
    y2: 401.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3CDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_213_5396",
    x1: 491.84,
    y1: 335.699,
    x2: 504.324,
    y2: 358.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_213_5396",
    x1: 512.838,
    y1: 232.105,
    x2: 494.966,
    y2: 341.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_213_5396",
    x1: -74.9386,
    y1: 174.252,
    x2: -244.51,
    y2: 759.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_213_5396",
    x1: 141.572,
    y1: 177.635,
    x2: 141.572,
    y2: 350.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3CDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_213_5396",
    x1: 130.836,
    y1: 223.835,
    x2: 130.836,
    y2: 405.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3CDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_213_5396",
    x1: 111.899,
    y1: 155.637,
    x2: -54.1785,
    y2: 734.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_213_5396",
    x1: 447.238,
    y1: 201.35,
    x2: 412.302,
    y2: 352.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_213_5396",
    x1: 403.678,
    y1: 324.401,
    x2: 410.327,
    y2: 368.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84F0A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_213_5396",
    x1: 66.6842,
    y1: 179.556,
    x2: -81.627,
    y2: 722.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_213_5396",
    x1: 325.511,
    y1: 262.943,
    x2: 329.882,
    y2: 338.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2A53A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_213_5396",
    x1: 308.065,
    y1: 281.55,
    x2: 308.065,
    y2: 370.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_213_5396",
    x1: 260.612,
    y1: 126.781,
    x2: 17.3734,
    y2: 551.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_213_5396",
    x1: 253.264,
    y1: 238.876,
    x2: 204.271,
    y2: 478.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_213_5396",
    x1: 161.475,
    y1: 101.274,
    x2: 53.1392,
    y2: 921.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_213_5396",
    x1: 540.522,
    y1: 190.995,
    x2: 428.706,
    y2: 661.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_213_5396",
    x1: 146.702,
    y1: 232.956,
    x2: 129.335,
    y2: 582.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_213_5396",
    x1: 620.625,
    y1: 884.628,
    x2: 618.601,
    y2: 793.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536DB5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E284B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_213_5396",
    x1: 47.1854,
    y1: 16.7809,
    x2: 49.5776,
    y2: -7.34073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536DB5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E284B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.a9a11c298f0c3e5111f212ddd2a367b1.svg";
export { ForwardRef as ReactComponent };